import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import Products from '@/components/Products'
import NewProduct from '@/components/NewProduct'
import EditProduct from '@/components/EditProduct'
import Websites from '@/components/Websites'
import NewWebsite from '@/components/NewWebsite'
import EditWebsite from '@/components/EditWebsite'
import ReportProducts from '@/components/ReportProducts'
import ReportProductSku from '@/components/ReportProductSku'
import ReportProductTable from '@/components/ReportProductTable'
import ReportProductDate from '@/components/ReportProductDate'
import ReportTableWebsites from '@/components/ReportTableWebsites'
import Reports from '@/components/Reports'
import ReportPricesHigh from '@/components/ReportPricesHigh'
import ReportPricesLow from '@/components/ReportPricesLow'
import WebsiteProducts from '@/components/WebsiteProducts'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/products',
      name: 'Products',
      component: Products,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/products/new',
      name: 'NewProduct',
      component: NewProduct,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/products/:id',
      name: 'EditProduct',
      component: EditProduct,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/websites',
      name: 'Websites',
      component: Websites,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/websites/new',
      name: 'NewWebsite',
      component: NewWebsite,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/websites/:id',
      name: 'EditWebsite',
      component: EditWebsite,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/websiteproducts/:id',
      name: 'WebsiteProducts',
      component: WebsiteProducts,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports',
      name: 'Reports',
      component: Reports,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports/products',
      name: 'ReportProducts',
      component: ReportProducts,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports/tablewebsites',
      name: 'ReportTableWebsites',
      component: ReportTableWebsites,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports/product/:sku',
      name: 'ReportProductSku',
      component: ReportProductSku,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports/producttable/:sku',
      name: 'ReportProductTable',
      component: ReportProductTable,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports/productdate/:sku',
      name: 'ReportProductDate',
      component: ReportProductDate,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports/priceshigh',
      name: 'ReportPricesHigh',
      component: ReportPricesHigh,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports/priceslow',
      name: 'ReportPricesLow',
      component: ReportPricesLow,
      meta: {
        requiresAuth: true
      }
    }

  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt') == null) {
      next({
        path: '/login',
        params: {nextUrl: to.fullPath}
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('jwt') == null) {
      next()
    } else {
      next({name: 'userboard'})
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js